import * as React from 'react';
import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { BreakingList } from '../detail/components/layout/BreakingList';

interface Props {
  children: ReactNode[];
  icon?: ReactNode;
  initial?: boolean;
  breakpoint?: 'xl' | 'lg' | 'md' | 'sm' | 'always';
}

export const HierarchyBlock: React.FC<Props> = (props: Props): ReactNode => {
  const breakPoint: 'xl' | 'lg' | 'md' | 'sm' | 'always' = props.breakpoint || 'md';
  const prefix: string = breakPoint === 'always' ? '' : `${breakPoint}:`;
  return <BreakingList separator={''} breakpoint={props.breakpoint}>
    {props.children
      .map((hierarchyItem: ReactNode, index: number): ReactNode =>
        <div key={index} className={'flex gap-1 align-content-center'}>
          <span className={`inline ${prefix}hidden`} style={{width: `${0.5 * (index)}rem`}}></span>
          {index !== 0 && <span className={'text-400 text-xl'}><FontAwesomeIcon icon={faCaretRight}/></span>}
          {hierarchyItem}
        </div>
      )}
  </BreakingList>;
};
